import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import SimpleStockList from './SimpleStockList';


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && <Box style={{ paddingLeft: 10, paddingRight: 2, paddingTop: 20, paddingBottom: 20 }} p={3}>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}


const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,

    },
}));

export default function WinerDetailsMenu(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [subtabIndex, setSubtabIndex] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue)
        setSubtabIndex(0)
    };

    return (
        <div className={classes.root} style={{}}>
            <Typography style={{textAlign: 'center', marginTop: 20}} variant="h6">{props.name}({props.id})統計表</Typography>
            <AppBar position="static"  color="default" style={{marginTop: 20}}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    <Tab label="交易明細" {...a11yProps(0)} />
                    <Tab label="近1日買超張數排行" {...a11yProps(1)} />
                    <Tab label="近1日賣超張數排行" {...a11yProps(2)} />
                    <Tab label="近1日買超金額排行" {...a11yProps(3)} />
                    <Tab label="近1日賣超金額排行" {...a11yProps(4)} />
                    
                    <Tab label="近5日買超張數排行" {...a11yProps(5)} />
                    <Tab label="近5日賣超張數排行" {...a11yProps(6)} />
                    <Tab label="近5日買超金額排行" {...a11yProps(7)} />
                    <Tab label="近5日賣超金額排行" {...a11yProps(9)} />
                </Tabs>
            </AppBar>


            {value === 0 ? <TabPanel value={value} index={0}>
                <SimpleStockList rid={'705'} value1={props.day} value2={props.bs} dealer={props.id} ismobile={props.ismobile} />
            </TabPanel> : null}
            {value === 1 ? <TabPanel value={value} index={1}>
                <SimpleStockList rid={'705'} value1={"1"} value2={"0"} dealer={props.id} ismobile={props.ismobile} />
            </TabPanel> : null}
            {value === 2 ? <TabPanel value={value} index={2}>
                <SimpleStockList rid={'705'} value1={"1"} value2={"1"} dealer={props.id} ismobile={props.ismobile} />
            </TabPanel> : null}
            {value === 3 ? <TabPanel value={value} index={3}>
                <SimpleStockList rid={'712'} value1={"1"} value2={"0"} dealer={props.id} ismobile={props.ismobile} />
            </TabPanel> : null}
            {value === 4 ? <TabPanel value={value} index={4}>
                <SimpleStockList rid={'712'} value1={"1"} value2={"1"} dealer={props.id} ismobile={props.ismobile} />
            </TabPanel> : null}

            {value === 5 ? <TabPanel value={value} index={5}>
                <SimpleStockList rid={'705'} value1={"5"} value2={"0"} dealer={props.id} ismobile={props.ismobile} />
            </TabPanel> : null}
            {value === 6 ? <TabPanel value={value} index={6}>
                <SimpleStockList rid={'705'} value1={"5"} value2={"1"} dealer={props.id} ismobile={props.ismobile} />
            </TabPanel> : null}
            {value === 7 ? <TabPanel value={value} index={7}>
                <SimpleStockList rid={'712'} value1={"5"} value2={"0"} dealer={props.id} ismobile={props.ismobile} />
            </TabPanel> : null}
            {value === 8 ? <TabPanel value={value} index={8}>
                <SimpleStockList rid={'712'} value1={"5"} value2={"1"} dealer={props.id} ismobile={props.ismobile} />
            </TabPanel> : null}
        </div>
    );
}
